import { PaySpanIcon } from "Components/Icons";
import useStyles from "./styles";
import React, { FC } from "react";
import { PaySpan } from "Shared/types/Payments";
import Tooltip from "@material-ui/core/Tooltip";
import RelatedPaymentTooltipTitle from "../RelatedTooltipTitle/RelatedPaymentTooltipTitle";

// note the div wrapping the icon is necessary for auto-ref assignment
// https://material-ui.com/guides/composition/#caveat-with-refs
const RelatedPaymentTooltip: FC<PaySpan> = (paySpan) => {
  const classes = useStyles();
  return (
    <Tooltip placement="top" title={<RelatedPaymentTooltipTitle {...paySpan}/>}>
      <div>
        <PaySpanIcon
          className={classes.paySpanIcon}
          aria-label="See pay details"
          color="inherit"
        />
      </div>
    </Tooltip>
  );
};

export default RelatedPaymentTooltip;
